import { c as _c } from "react/compiler-runtime";
import { Drawer } from '@base-ui/react/drawer';
import { Popover } from '@systemeio/components';
import { Bell03Icon } from '@systemeio/icons';
import { NotificationsMenuContent } from 'modules/notifications/components/notifications-menu-content';
import { useNotifications } from 'modules/notifications/hooks/use-notifications';
import { useOpenNotificationMenuQuery } from 'modules/notifications/hooks/use-open-notification-menu-query';
import { useEffect, useRef } from 'react';
import { NavbarDrawer } from 'shared/components/navbar/components/navbar-drawer';
import { NAVBAR_HOVER_OPEN_DELAY, NAVBAR_ICON_BUTTON_CLASS_NAME, NAVBAR_PANEL_CLASS_NAME } from 'shared/components/navbar/constants';
import { focusPanelOnKeyboardOpenOnly } from 'shared/components/navbar/utils/focus-panel-on-keyboard-open-only';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { twJoin } from 'tailwind-merge';
const defaultNotificationFilter = {
  onlyUnRead: false
};
interface NotificationsProps {
  isDesktop: boolean;
}
export function Notifications(t0) {
  const $ = _c(35);
  const {
    isDesktop
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const triggerRef = useRef(null);
  const drawerActionsRef = useRef(null);
  const {
    pagination
  } = usePagination(true);
  const t1 = isDesktop ? 3 : 10;
  let t2;
  if ($[0] !== pagination || $[1] !== t1) {
    t2 = {
      shouldFetchNotifications: false,
      limit: t1,
      pagination,
      filter: defaultNotificationFilter
    };
    $[0] = pagination;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    notificationsMeta
  } = useNotifications(t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      allowCheck: true
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    openThroughQuery,
    setOpenThroughQuery
  } = useOpenNotificationMenuQuery(t3);
  let t4;
  let t5;
  if ($[4] !== openThroughQuery) {
    t4 = () => {
      if (openThroughQuery) {
        triggerRef.current?.click();
      }
    };
    t5 = [openThroughQuery];
    $[4] = openThroughQuery;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Bell03Icon className="size-5" />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== notificationsMeta?.hasUnread) {
    t7 = notificationsMeta?.hasUnread && <UnreadIndicator />;
    $[8] = notificationsMeta?.hasUnread;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const triggerContent = t8;
  if (!isDesktop) {
    let t9;
    if ($[12] !== setOpenThroughQuery) {
      t9 = open => !open && setOpenThroughQuery(false);
      $[12] = setOpenThroughQuery;
      $[13] = t9;
    } else {
      t9 = $[13];
    }
    let t10;
    if ($[14] !== t) {
      t10 = t("dashboard.notifications.title");
      $[14] = t;
      $[15] = t10;
    } else {
      t10 = $[15];
    }
    let t11;
    if ($[16] !== t10 || $[17] !== triggerContent) {
      t11 = <Drawer.Trigger aria-label={t10} className={NAVBAR_ICON_BUTTON_CLASS_NAME} data-test-id="notifications-button" ref={triggerRef}>{triggerContent}</Drawer.Trigger>;
      $[16] = t10;
      $[17] = triggerContent;
      $[18] = t11;
    } else {
      t11 = $[18];
    }
    let t12;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <NavbarDrawer actionsRef={drawerActionsRef}><NotificationsMenuContent className="h-full w-full" limit={10} onNavigate={() => drawerActionsRef.current?.close()} /></NavbarDrawer>;
      $[19] = t12;
    } else {
      t12 = $[19];
    }
    let t13;
    if ($[20] !== t11 || $[21] !== t9) {
      t13 = <Drawer.Root actionsRef={drawerActionsRef} disablePointerDismissal={true} modal={false} onOpenChange={t9} swipeDirection="right">{t11}{t12}</Drawer.Root>;
      $[20] = t11;
      $[21] = t9;
      $[22] = t13;
    } else {
      t13 = $[22];
    }
    return t13;
  }
  let t9;
  if ($[23] !== setOpenThroughQuery) {
    t9 = open_0 => !open_0 && setOpenThroughQuery(false);
    $[23] = setOpenThroughQuery;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t) {
    t10 = t("dashboard.notifications.title");
    $[25] = t;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== triggerContent) {
    t11 = <Popover.Trigger aria-label={t10} className={NAVBAR_ICON_BUTTON_CLASS_NAME} data-test-id="notifications-button" delay={NAVBAR_HOVER_OPEN_DELAY} openOnHover={true} ref={triggerRef}>{triggerContent}</Popover.Trigger>;
    $[27] = t10;
    $[28] = triggerContent;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = twJoin(NAVBAR_PANEL_CLASS_NAME, "max-w-(--available-width)");
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Popover.Portal><Popover.Positioner align="end" className="z-60" sideOffset={4}><Popover.Popup className={t12} initialFocus={focusPanelOnKeyboardOpenOnly}><NotificationsMenuContent /></Popover.Popup></Popover.Positioner></Popover.Portal>;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t11 || $[33] !== t9) {
    t14 = <Popover.Root onOpenChange={t9}>{t11}{t13}</Popover.Root>;
    $[32] = t11;
    $[33] = t9;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  return t14;
}
function UnreadIndicator() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span aria-hidden={true} className="bg-bg-accent-active absolute top-1.5 right-1.5 size-2 rounded-full" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}